import {
  DataService,
  TypedBaseListComponent,
  SharedModule,
  NotificationService,
  ModalService,
} from "@bb-vendure/admin-ui/core";

import { Component } from "@angular/core";
import {
  AllPackagesDocument,
} from "src/generated-gql/graphql";
import { take, Observable } from "rxjs";
import { DataTable2Component } from "../package-review/List/custom-table/data-table2.component";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
  templateUrl: "./package-summary.component.html",
  standalone: true,
  imports: [
    SharedModule,
    DataTable2Component,
  ],
})
export class PackageSummaryComponent extends TypedBaseListComponent<
  typeof AllPackagesDocument,
  "packages"
> {
  activeRowId$: Observable<string | null>;
  expandedIds: string[] = [];
  expandedRowIndex: number | null = null;

  constructor(
    protected dataService: DataService,
    private notificationService: NotificationService,
    protected modalService: ModalService,
    protected route: ActivatedRoute,
    protected router: Router
  ) {
    super();
    super.configure({
      document: AllPackagesDocument,
      getItems: (data) => {
        return data.packages;
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            batchNumber: this.searchTermControl.value ? {
              contains: this.searchTermControl.value,
            } : undefined,
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.sorts.valueChanges,
        this.filters.valueChanges,
        this.searchTermControl.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addFilter({
      name: "batchNumber",
      type: { kind: "text" },
      label: _("package.batch-number"),
      filterField: "batchNumber"
    })
    // status is select
    .addFilter({
      name: "status",
      type: { kind: "select", options: [
        { label: _("Package Requested"), value: "Package Requested" },
        { label: _("Shipment Requested"), value: "Shipment Requested" },
        { label: _("Packed"), value: "Packed" },
        { label: _("Shipped"), value: "Shipped" },
        { label: _("Delivered"), value: "Delivered" },
        { label: _("Cancelled"), value: "Cancelled" },
      ] },
      label: _("package.package-status"),
      filterField: "status"
    })
    .addFilter({
      name: "orderId",
      type: { kind: "id" },
      label: _("package.orderId"),
      filterField: "orderId"
    })
    .addIdFilter()
    .addDateFilters()
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([
      { name: "id" },
      { name: "createdAt" },
      { name: "updatedAt" },
      { name: "totalQuantity" },
      { name: "estimatedWeight" },
      { name: "status" },
    ]);

  ngOnInit() {
    super.ngOnInit();
  }

  getStatusColor(status: string): string {
    switch (status) {
      case "Packed":
        return "success";
      case "Package Requested":
        return "warning";
      case "Shipment Requested":
        return "info";
      case "Shipped":
        return "primary";
      case "Delivered":
        return "success";
      case "Cancelled":
        return "error";
      default:
        return "neutral";
    }
  }

  setRowExpand(index: number) {
    if (this.expandedRowIndex === index) {
      this.expandedRowIndex = null;
    } else {
      this.expandedRowIndex = index;
    }
  }

  closeContents() {
    const params = { ...this.route.snapshot.params };
    delete params.contents;
    this.router.navigate(["./", params], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

}
